module.exports = __webpack_public_path__ + "img/journals.318b7650.svg";